module.exports = __webpack_public_path__ + "media/images/lb/967-c3817624df105cbc09907ea41e170d30.svg";